import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RouteSheetTable from "./ReportTables/RouteSheetTable";
import { filtrationcontext } from "../../context/Filtercontext";
import { useLocation } from "react-router-dom";
import TripsSheetTable from "./ReportTables/TripsSheetTable";
import StopSheetTable from "./ReportTables/StopSheetTable";
import SpeedSheetTable from "./ReportTables/SpeedSheetTable";
import DistanceSheetTable from "./ReportTables/DistanceSheetTable";
import ReportSheetsHead from "./ReportSheets/ReportSheetsHead/ReportSheetsHead";
import ReportSheetsTotal from "./ReportPage/ReportComponents/ReportSheetsTotal";
import FuelSheetTable from "./ReportTables/FuelSheetTable";
import OdometerSheetTable from "./ReportTables/OdometerSheetTable";

const Report = () => {
  const { setSearchQuery, searchQuery } = useContext(filtrationcontext);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const inf = useSelector((state) => state.users.user);
  const [selectedUser, setSelectedUser] = useState(inf.id);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [isShown, setIsShown] = useState(false);
  const [totalData, setTotalData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedids, setIds] = useState([]);
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState([]);
  const { pathname } = useLocation();
  const getShortPath = () => pathname.split("/").pop();
  const shortPath = getShortPath();
  const [sumIds, setSumIds] = useState("");
  useEffect(() => {
    if (selectedVehicles) {
      let ids;
      let longIds;
      if (shortPath === "devicebehavior") {
        ids = selectedVehicles;
        longIds = `deviceId=${selectedVehicles}`;
      } else {
        ids = selectedVehicles.map((i) => Number(i)).join(",");
        longIds = selectedVehicles.map((id) => `deviceId=${id}`).join("&");
      }
      setIds(longIds);
      setSumIds(ids);
      setCurrentPage(1);
      setSearchQuery("");
    }
  }, [selectedVehicles]);
  useEffect(() => {
    if (selectedGroupId) {
      const longIds = selectedGroupId
        .map((id) => `groupId=${id.value}`)
        .join("&");
      setSelectedGroupIds(longIds);
    }
  }, [selectedGroupId]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);
  return (
    <>
      <ReportSheetsHead
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        selectedUser={selectedUser}
        selectedVehicles={selectedVehicles}
        setSelectedUser={setSelectedUser}
        setSelectedVehicles={setSelectedVehicles}
        isShown={isShown}
        setIsShown={setIsShown}
        selectedGroupId={selectedGroupId}
        setSelectedGroupId={setSelectedGroupId}
      />
      <div className="report-view">
        <div className="report-sheets">
          {shortPath === "devicebehavior" ? (
            <></>
          ) : (
            <ReportSheetsTotal data={totalData} />
          )}
          {shortPath === "devicebehavior" ? (
            <RouteSheetTable
              startDate={startDate}
              endDate={endDate}
              selectedids={selectedids}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isShown={isShown}
              sumIds={sumIds}
            />
          ) : shortPath === "vehiclestrips" ? (
            <TripsSheetTable
              startDate={startDate}
              endDate={endDate}
              selectedids={selectedids}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isShown={isShown}
              setTotalData={setTotalData}
              sumIds={sumIds}
            />
          ) : shortPath === "stop" ? (
            <StopSheetTable
              startDate={startDate}
              endDate={endDate}
              selectedids={selectedids}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isShown={isShown}
              setTotalData={setTotalData}
              sumIds={sumIds}
            />
          ) : shortPath === "speed" ? (
            <SpeedSheetTable
              startDate={startDate}
              endDate={endDate}
              selectedids={selectedids}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isShown={isShown}
              setTotalData={setTotalData}
              sumIds={sumIds}
              selectedGroupId={selectedGroupId}
              selectedGroupIds={selectedGroupIds}
            />
          ) : shortPath === "distance" ? (
            <DistanceSheetTable
              startDate={startDate}
              endDate={endDate}
              selectedids={selectedids}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isShown={isShown}
              setTotalData={setTotalData}
              sumIds={sumIds}
              selectedGroupId={selectedGroupId}
              selectedGroupIds={selectedGroupIds}
            />
          ) : shortPath === "fuel" ? (
            <FuelSheetTable
              startDate={startDate}
              endDate={endDate}
              selectedids={selectedids}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isShown={isShown}
              setTotalData={setTotalData}
              sumIds={sumIds}
              selectedGroupId={selectedGroupId}
              selectedGroupIds={selectedGroupIds}
            />
          ) : shortPath === "odometer" ? (
            <OdometerSheetTable
              startDate={startDate}
              endDate={endDate}
              selectedids={selectedids}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isShown={isShown}
              setTotalData={setTotalData}
              sumIds={sumIds}
              selectedGroupId={selectedGroupId}
              selectedGroupIds={selectedGroupIds}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default Report;
